module.exports = __webpack_public_path__ + "img/V43.640fe486.jpg";